export default path =>
  path.split(/(?:node)?\.nodes\.([a-z0-9]*)/).filter(Boolean)



// WEBPACK FOOTER //
// ./src/utils/nodePathToArray.js